// salesOrderListDisplay.ts — Round E2 (2026-09-15), spec R8 + R9, web list.
//
// The API adds `paymentConfirmationStatus` (latest row) and `customerName` /
// `dealerName` to GET /sales-orders. These pure helpers keep the table cell
// logic out of the JSX so it can be tested.

export const PENDING_PC_LABEL = 'Pending PC';

export function isPendingPc(paymentConfirmationStatus?: string | null): boolean {
  return String(paymentConfirmationStatus ?? '').trim().toLowerCase() === 'pending';
}

export interface ListRowNames {
  contact?: { firstName?: string | null; lastName?: string | null } | null;
  account?: { name?: string | null } | null;
  customerName?: string | null;
  dealerName?: string | null;
  buyerType?: string | null;
}

/** "Dealer" on a stock sale, "via <dealer>" on a dealer-channel sale, else null. */
export function dealerTag(row: ListRowNames): string | null {
  if (row.buyerType === 'dealer') return 'Dealer';
  const d = (row.dealerName ?? '').trim();
  return d ? `via ${d}` : null;
}

/** True when the row has neither a contact nor an account to print. */
export function needsCustomerFallback(row: ListRowNames): boolean {
  return !row.contact && !row.account;
}

/** The fallback text for a contact-less row: server customerName, else '-'. */
export function fallbackCustomerText(row: ListRowNames): string {
  const n = (row.customerName ?? '').trim();
  return n || '-';
}
